import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Button, ButtonIcon, IconCopy, useToast } from 'braid-design-system';
import React from 'react';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import translations from './.vocab';

export const CopyButton = ({
  profileUrl,
  isEditState,
  variant = 'button',
}: {
  profileUrl: string;
  isEditState: boolean;
  variant?: 'buttonIcon' | 'button';
}) => {
  const showToast = useToast();
  const { shareableProfileButtonPressed } = useAnalytics();
  const { t } = useTranslations(translations);

  const onCopyClick = () => {
    navigator.clipboard.writeText(profileUrl);
    shareableProfileButtonPressed({
      eventName: 'profile_link_copy_pressed',
      isEditState,
    });
    showToast({
      key: 'link-copied',
      tone: 'positive',
      message: t('Link copied'),
    });
    metrics.count('shareable_profile_url_copied');
  };

  return variant === 'button' ? (
    <Button
      variant="ghost"
      tone="formAccent"
      icon={<IconCopy />}
      onClick={onCopyClick}
    >
      {t('Copy')}
    </Button>
  ) : (
    <ButtonIcon
      id="copyProfileUrl"
      data={{ automation: 'copy-btn' }}
      variant="transparent"
      bleed={false}
      icon={<IconCopy />}
      label={t('Copy')}
      onClick={onCopyClick}
    />
  );
};
